<ng-container *ngComponentOutlet="LoaderComponent">
</ng-container>
<div mat-dialog-title style="position: relative;"  *ngIf="!keyword && !advanced">
    <p style="font-weight: bold; background-color: #efefef; color: #c89d07;padding: 8px;margin-top: -8px;
    margin-left: -24px;margin-right: -24px;">
        Reason
    </p>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close"
       (click)="onNoClick()" style="color: black; top: 0px;left: 470px;position: absolute;">
        <span aria-hidden="true" class="">&times;</span>
    </button>
</div>
<div mat-dialog-content class="dialog-content"  *ngIf="!keyword && !advanced">
    <form [formGroup]="reasonform">
        <div>
            <span style="color: red;">Reason* </span>
        </div>
        <div class="row  ka-em-content" style="margin-left: 1px;">

            <textarea class="form-control" formControlName="reasonForPrint" rows="7" required></textarea>
                <div [hidden]="!reasonform.controls['reasonForPrint'].errors?.required" class="error-msg">
                    Reason is required.
                </div>
                <div *ngIf="reasonform.controls['reasonForPrint'].hasError('minlength')" class="error-msg">
                    Minimum 20 Characters Required
                </div>


        </div>

    </form>

    <div class="action-buttons" style="justify-content: center; display: flex;">
        <button mdbBtn class="ka-white-button  tButton ka-btn-primary btn-success btn mb-3 mt-2"
            mdbWavesEffect type="submit" (click)="onSubmitResponse()" [disabled]="reasonform.invalid">Submit
        </button>
        <p style="cursor: pointer;" (click)="onNoClick()" style="margin-top: 22px;
        padding-left: 2%;"> <span>Cancel</span></p>

    </div>
</div>

<div mat-dialog-title style="position: relative;"  *ngIf="keyword">
    <p style="font-weight: bold; background-color: #efefef; color: #c89d07;padding: 8px;margin-top: -8px;
    margin-left: -24px;margin-right: -24px;text-align: center;">
        Print Preview
    </p>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close"
       (click)="onNoClick()" style="color: black; top: 0px;right: 0;position: absolute;">
        <span aria-hidden="true" class="">&times;</span>
    </button>
</div>

<div mat-dialog-content class="dialog-content1 watermark-bg" *ngIf="keyword">
    <div class="row justify-content-center ka-em-printContent">
        <button mdbBtn
        class="ka-white-button tButton ka-btn-primary btn-success btn mb-3 mt-2 ka-normalButton-height"
        style="width:auto;" mdbWavesEffect type="submit" (click)="printMarketingData()"><i class="fa fa-print"
            aria-hidden="true"></i> Print</button>
    </div>
    <div class="ka-em-printContent p-3 m-3" id="print-section" #content>
        <div *ngIf="keywordPrintAddress.zipcode"  style="font-family: Calibri;">
            <div  style="font-weight: 700!important; text-decoration: underline;font-family: Calibri;">Address :</div>
            <div>{{keywordPrintAddress.line1}}</div>
            <div>{{keywordPrintAddress.line2}}</div>
            <div>{{keywordPrintAddress.zipcode}}</div>
            <hr>
        </div>
        
        <div *ngFor="let details of keywordPrintData">
            <div class="row" style="font-family: Calibri;margin: 10px 0px 30px 0px;" *ngIf="details.printData !== null">
                <span class="col-2 p-0" style="font-weight: 700!important;cursor: pointer;" (click)="redirectToViewProfile(details.profileID)">Customer ID - {{details.custID}} : </span>
                <span class="col-8">{{details.printData}}</span>
                <p class="ka-view-linebreak">
                    <span style="visibility: hidden;height: 0px;display: block;">hide</span>
                </p>
            </div>
            
        </div>
    </div>
</div>
<div mat-dialog-title style="position: relative;"  *ngIf="advanced">
    <p style="font-weight: bold; background-color: #efefef; color: #c89d07;padding: 8px;margin-top: -8px;
    margin-left: -24px;margin-right: -24px;text-align: center;">
        Print Preview
    </p>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close"
       (click)="onNoClick()" style="color: black; top: 0px;right: 0;position: absolute;">
        <span aria-hidden="true" class="">&times;</span>
    </button>
</div>

<div mat-dialog-content class="dialog-content1 watermark-bg" *ngIf="advanced">
    <div class="row justify-content-center ka-em-printContent">
        <button mdbBtn
        class="ka-white-button tButton ka-btn-primary btn-success btn mb-3 mt-2 ka-normalButton-height"
        style="width:auto;" mdbWavesEffect type="submit" (click)="printMarketingData()"><i class="fa fa-print"
            aria-hidden="true"></i> Print</button>
    </div>
    <div class="ka-em-printContent p-3 m-3" id="print-section" #content> 
        <div *ngIf="advancedPrintAddress.zipcode"  style="font-family: Calibri;">
            <div  style="font-weight: 700!important; text-decoration: underline;font-family: Calibri;">Address :</div>
            <div>{{advancedPrintAddress.line1}}</div>
            <div>{{advancedPrintAddress.line2}}</div>
            <div>{{advancedPrintAddress.zipcode}}</div>
            <hr>
        </div>
        <div *ngFor="let details of advancedPrintData">
            <div class="row" style="font-family: Calibri;margin: 10px 0px 30px 0px;" *ngIf="details.printData !== null">
                <span class="col-2 p-0" style="font-weight: 700!important;cursor: pointer;" (click)="redirectToViewProfile(details.profileID)">Customer ID - {{details.custID}} : </span>
                <span class="col-8">{{details.printData}}</span>
                <p class="ka-view-linebreak">
                    <span style="visibility: hidden;height: 0px;display: block;">hide</span>
                </p>
            </div>
            
        </div>
    </div>
</div>